import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 复制表格
  {path:"/copytable", name:"copytable", component: () => import("@/views/webpage/copytable.vue")},
  {path:"/pcindex", name:"pcindex", component: () => import("@/views/webpage/index.vue")},
  {path:"/", name:"index", meta:{keepAlive: true}, component: () => import("@/views/index.vue")},
  {path: '/login',name: 'login',component: ()=>import('@/views/login.vue')},
  {path:"/hkdemo", name:"hkdemo", meta:{keepAlive: true}, component: () => import("@/views/index1.vue")},
  {path:"/analysisCurve", name:"AnalysisCurve", component: () => import("@/views/analysisCurve.vue")},
  {path:"/countCharts", name:"CountCharts", component: () => import("@/views/countCharts.vue")},
  {path:"/countTable", name:"CountTable", component: () => import("@/views/countTable.vue")},
  {path:"/taosAnalysis", name:"TaosAnalysis", component: () => import("@/views/taosAnalysis.vue")},
  {path:"/wetWarnCurvexjh", name:"WetWarnCurvexjh", component: () => import("@/views/wetWarnCurvexjh.vue")},
  {path:"/wetWarnCurveyjy", name:"WetWarnCurveyjy", component: () => import("@/views/wetWarnCurveyjy.vue")},
  {path:"/messageshow", name:"Messageshow", component: () => import("@/views/messageshow.vue")},
  {path:"/alarmInfo", name:"AlarmInfo", component: () => import("@/views/alarmInfo.vue")},
  {path:"/apiCurve", name:"ApiCurve", component: () => import("@/views/apiCurve.vue")},
  {path:"/netStatus", name:"NetStatus", component: () => import("@/views/netStatus.vue")},
  {path:"/taosDataStatus", name:"TaosDataStatus", component: () => import("@/views/taosDataStatus.vue")},
  {path:"/taosData", name:"TaosData", component: () => import("@/views/taosData.vue")},
  {path:"/itemclassData", name:"ItemclassDataData", component: () => import("@/views/itemclassData.vue")},
  {path:"/datatableData", name:"DatatableData", component: () => import("@/views/datatableData.vue")},
  {path:"/qualityCockpit", name:"QualityCockpit", component: () => import("@/views/qualityCockpit.vue")},
  {path:"/logisticsCockpit", name:"LogisticsCockpit", component: () => import("@/views/logisticsCockpit.vue")},
  {path:"/sendOutGoodsCount", name:"SendOutGoodsCount", component: () => import("@/views/sendOutGoodsCount.vue")},
  {path:"/conCastingDay", name:"ConCastingDay", component: () => import("@/views/conCastingDay.vue")},
  {path:"/conCastingMonth", name:"ConCastingMonth", component: () => import("@/views/conCastingMonth.vue")},
  {path:"/spectrumMonth", name:"SpectrumMonth", component: () => import("@/views/spectrumMonth.vue")},
  {path:"/spectrumDay", name:"SpectrumDay", component: () => import("@/views/spectrumDay.vue")},
  {path:"/spectrumWeek", name:"SpectrumWeek", component: () => import("@/views/spectrumWeek.vue")},
  {path:"/spectrumTimesList", name:"SpectrumTimesList", component: () => import("@/views/spectrumTimesList.vue"), meta:{keepAlive: true}},
  {path:"/spectrumTimesListDetail", name:"SpectrumTimesListDetail", component: () => import("@/views/spectrumTimesListDetail.vue")},
  {path:"/zcreportDay", name:"ZcreportDay", component: () => import("@/views/zcreportDay.vue")},
  {path:"/zcreportMonth", name:"ZcreportMonth", component: () => import("@/views/zcreportMonth.vue")},
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: 'history',
  routes
})
// router.beforeEach((to, from, next) =>{

//   let token = sessionStorage.getItem("myToken")
//   if(to.path === "/login"){
//       next()
//       return
//   }
//   //next()
//   if(!token){
//       next({path:"/login"})
//   }else{
//       next()
//   }
// })

export default router
